import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react'
import SourcingSummaryComponent from '../../sourcing/SourcingSummaryCompoenent'
import { useAppReportsStore, Report } from '../../../stores/appReportsStore'
import { Product } from '../../../stores/appReportsStore'

export default function ReportSummaryPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { reportId } = useParams<{ reportId: string }>()

  // grab report
  const report: Report | undefined = useAppReportsStore(s =>
    reportId ? s.reportsById[reportId] : undefined
  )

  useEffect(() => {
    if (!report) navigate('/reports-legacy')
  }, [report, navigate])


  if (!report) return null

  // extract sourcing data
  const sd = report.sourcingData as {
    productsIdMap: Record<string, Product>
    selectedOptionIdMap: Record<string, Product>
  }
  const productsMap = sd.productsIdMap
  const selectedMap = sd.selectedOptionIdMap

  const filteredProductsMap = productsMap
  const filteredSelectedPairs = selectedMap

  return (
    <div className="min-h-full p-6">
      {/* header */}
      <div className="max-w-7xl mx-auto mt-1 mb-6 flex items-center justify-between">
        <div className="flex items-center">
          <button
          onClick={() => navigate(`/reports-legacy/${reportId}`)}
          aria-label={t('import.goBack')}
            className="flex items-center"
          >
            <ArrowLeft className="transition hover:scale-110 w-10 h-6 text-text dark:text-text-dark" />
          </button>
          <h1 className="text-2xl font-bold text-text dark:text-text-dark pl-1">
          {t('sourcing.summaryTitle')}
          </h1>
        </div>
        <div />
      </div>

      {/* summary content */}
      <SourcingSummaryComponent
        productsMap={filteredProductsMap}
        selectedMap={filteredSelectedPairs}
      />
    </div>
  )
}
